"use strict";

var GvmsManifesto = function () {
  var origin_port, destination_port;
  $("#contract_type_div").hide();
  var set_carrier_on_gvmss = function(origin_port, destination_port) {
    return $.ajax({
      type: "GET",
      url: "/gvms_manifestos/set_carrier?departurePortId=" + origin_port +'&'+"arrivalPortId=" + destination_port,
      dataType: "JSON",
      success: function(data){
        var myOpts = document.getElementById('gvms_manifesto_ferry_operator_code').options;
        for (var i = 0; i < myOpts.length; i++) {
          if(!data.includes(parseInt(myOpts[i].value))) {
            myOpts[i].disabled = true
          } else {
            myOpts[i].disabled = false
          }
        }
        $("#gvms_manifesto_ferry_operator_code").val($("#gvms_manifesto_ferry_operator_code option:not([disabled]):first").val());
      }
    });
  };

  var set_carrier_on_gvms = function () {
    if(origin_port !== null && origin_port !== '' && destination_port !== null && destination_port !== '') {
      set_carrier_on_gvmss(origin_port, destination_port)
    }
  }

  var set_contract_type = function (has_good) {
    if(has_good) {
      $("#contract_type_div").hide();
    } else {
      $("#contract_type_div").show();
    }
  }

  return {
    init: function () {

       $(document).on("change", "#gvms_manifesto_origin_port_code", function() {
        origin_port = $('#gvms_manifesto_origin_port_code').val();
         if(origin_port !== null && destination_port !== null) {
           set_carrier_on_gvms(origin_port, null)
         }
       });

       $(document).on("change", "#gvms_manifesto_destination_port_code", function() {
         destination_port = $('#gvms_manifesto_destination_port_code').val();
         if(origin_port !== null && destination_port !== null) {
           set_carrier_on_gvms(null, destination_port)
         }
       });

      $(document).on("change", "#gvms_manifesto_destination_port_code", function() {
        destination_port = $('#gvms_manifesto_destination_port_code').val();
        set_carrier_on_gvmss(origin_port, destination_port)
      });

      $(document).on("change", "#gvms_manifesto_has_goods", function() {
        var has_good = document.getElementById("gvms_manifesto_has_goods");
        set_contract_type(has_good.checked)
      });

    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = GvmsManifesto;
}
